import { Users } from "lucide-react";
import { useNavigate } from "react-router-dom";

// Professional team images
import categoryDashboard from "@/assets/category-dashboard.jpg";
import categoryMeeting from "@/assets/category-meeting.jpg";
import categoryTeamwork from "@/assets/category-teamwork.jpg";
import categoryPlanning from "@/assets/category-planning.jpg";
import categoryCollaboration from "@/assets/category-collaboration.jpg";
import categoryConsulting from "@/assets/category-consulting.jpg";
import categoryPresentation from "@/assets/category-presentation.jpg";

const CategoriesSection = () => {
  const navigate = useNavigate();

  const categories = [
    { name: "Project Management", image: categoryDashboard, learners: "2.5K+", link: "Marketing" },
    { name: "Excel & Data", image: categoryPlanning, learners: "1.8K+", link: "Excel Files" },
    { name: "Business Templates", image: categoryMeeting, learners: "3.2K+", link: "Business" },
    { name: "Finance", image: categoryConsulting, learners: "1.5K+", link: "Finance" },
    { name: "KPI Dashboards", image: categoryTeamwork, learners: "980+", link: "KPI Dashboard" },
    { name: "Construction", image: categoryCollaboration, learners: "720+", link: "Construction Planning" },
    { name: "Modern Presentation", image: categoryPresentation, learners: "450+", link: "Modern Presentation" },
  ];

  return (
    <section className="py-12 lg:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">
            Learn essential project management skills
          </h2>
          <p className="text-muted-foreground">
            Fasttrack Hub helps you build in-demand skills and advance your career.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {categories.map((category) => (
            <button
              key={category.name}
              onClick={() => navigate(`/templates?category=${encodeURIComponent(category.link)}`)}
              className="group bg-card rounded-xl border border-border hover:shadow-lg transition-all duration-300 text-left flex flex-col"
            >
              {/* Image */}
              <div className="h-40 sm:h-48 lg:h-52 w-full overflow-hidden rounded-t-xl">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              {/* Content */}
              <div className="p-4">
                <div className="flex items-center gap-1 text-sm text-muted-foreground mb-1">
                  <Users className="h-4 w-4" />
                  <span>{category.learners}</span>
                </div>
                <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors">
                  {category.name}
                </h3>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
